import React from 'react';
import {Provider} from 'react-redux';
import {EdapProvider} from '@homeaway/react-event-tracking';
import {LocalizationContextProvider} from '@homeaway/react-localization-components';

import App from './components/App';

/**
 * Basic provider wrapping. This has been externalized in order to
 * enable hot module replacement features.
 */
const defaultFields = {eventcategory: 'thinhelp'};

/* istanbul ignore next */
function Root({store, siteContext}) {
    return (
        <Provider store={store}>
            <LocalizationContextProvider siteContext={siteContext}>
                <EdapProvider fields={defaultFields}>
                    <App />
                </EdapProvider>
            </LocalizationContextProvider>
        </Provider>
    );
}

export default Root;
